import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import PublicRoute from 'components/PublicRoute';

// load komponen login
const LoginComponent = Loadable(lazy(() => import('pages/auth/Login')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    // redirect root ke login
    {
      index: true,
      element: <Navigate to="/login" replace />
    },

    // halaman login (diproteksi PublicRoute)
    {
      path: 'login',
      element: (
        <PublicRoute>
          <LoginComponent />
        </PublicRoute>
      )
    },

    // optional: blok semua /login/*
    {
      path: 'login/*',
      element: <Navigate to="/login" replace />
    }
  ]
};

export default LoginRoutes;